"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WaitingSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var WaitingSVG = function WaitingSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M26,26H25c0-4.45-2-8.27-5-10,2.93-1.73,5-5.55,5-10h1a2,2,0,0,0,0-4H6A2,2,0,0,0,6,6H7c0,4.45,2,8.27,5,10C9,17.73,7,21.55,7,26H6a2,2,0,0,0,0,4H26a2,2,0,0,0,0-4ZM11,12H21c0,2-4.5,3-5,3S11,14,11,12ZM10,26c0-3,4.5-7,6-7s6,4,6,7Z"
  }));
};
exports.WaitingSVG = WaitingSVG;
WaitingSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(WaitingSVG);
exports.default = _default;